export function getConfigurationMaskId(configurationId: number) {
  return `${configurationId}-mask`;
}
